/* JG Mega Menu v6.0.0 */
(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const SELECTOR = '[data-jg-mega]';

  const closeAll = (except = null) => {
    document.querySelectorAll(`${SELECTOR}[open]`).forEach((details) => {
      if (details !== except) details.open = false;
    });
  };

  function init(root = document) {
    root.querySelectorAll(SELECTOR).forEach((details) => {
      if (details.dataset.jgReady === 'true') return;
      details.dataset.jgReady = 'true';

      let closeTimer = 0;
      const summary = details.querySelector(':scope > summary');
      const panel = details.querySelector('[data-jg-panel]');

      const openMenu = () => {
        if (!desktopQuery.matches) return;
        window.clearTimeout(closeTimer);
        closeAll(details);
        details.open = true;
      };

      const scheduleClose = () => {
        if (!desktopQuery.matches) return;
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          if (!details.matches(':hover') && !details.contains(document.activeElement)) details.open = false;
        }, 190);
      };

      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', scheduleClose);
      details.addEventListener('focusin', openMenu);
      details.addEventListener('focusout', scheduleClose);

      details.addEventListener('toggle', () => {
        if (details.open) closeAll(details);
      });

      summary?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          openMenu();
          panel?.querySelector('a')?.focus();
        }
      });
    });
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest(SELECTOR)) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openMenu = document.querySelector(`${SELECTOR}[open]`);
    if (!openMenu) return;
    const summary = openMenu.querySelector(':scope > summary');
    openMenu.open = false;
    summary?.focus();
  });

  desktopQuery.addEventListener?.('change', (event) => {
    if (!event.matches) closeAll();
  });

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
